
import { Link } from 'react-router-dom';
import { events } from '../../../mocks/events';
import AddToCalendarButton from '../../../components/feature/AddToCalendarButton';
import ShareEventButton from '../../../components/feature/ShareEventButton';
import RsvpButton from '../../../components/feature/RsvpButton';

export default function FeaturedEvents() {
  return (
    <section id="events" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Upcoming Events</h2>
          <Link 
            to="/events"
            className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            View All Events
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {events.map((event) => (
            <div key={event.id} className="group">
              <Link to={`/events/${event.id}`} className="cursor-pointer block">
                <div className="relative rounded-2xl overflow-hidden shadow-lg mb-4 h-72">
                  <img 
                    src={event.image} 
                    alt={event.title} 
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4 bg-white rounded-lg px-4 py-3 text-center shadow-lg">
                    <div className="text-teal-600 font-bold text-xs uppercase">{event.month}</div>
                    <div className="text-gray-900 font-bold text-2xl">{event.day}</div>
                  </div>
                  <div className="absolute top-4 right-4 flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <RsvpButton eventId={event.id} variant="icon" />
                    <ShareEventButton event={event} variant="icon" />
                    <AddToCalendarButton event={event} variant="icon" />
                  </div>
                </div>
              </Link>
              
              <div>
                <div className="flex items-center justify-between mb-3">
                  <span className="inline-block bg-amber-100 text-amber-700 text-xs font-semibold px-3 py-1 rounded-full">
                    {event.category}
                  </span>
                  <div className="flex items-center space-x-2">
                    <RsvpButton eventId={event.id} variant="compact" />
                    <ShareEventButton event={event} variant="compact" />
                    <AddToCalendarButton event={event} variant="compact" />
                  </div>
                </div>
                <Link to={`/events/${event.id}`} className="cursor-pointer block">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors">
                    {event.title}
                  </h3>
                  <div className="flex items-center text-gray-600 text-sm space-x-4">
                    <div className="flex items-center space-x-1">
                      <i className="ri-map-pin-line text-base"></i>
                      <span>{event.location}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <i className="ri-time-line text-base"></i>
                      <span>{event.time}</span>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
